import GetApp from '@material-ui/icons/GetApp';
import { Button } from 'react-admin';
import React from 'react';
import { download } from './download';

interface Props {
  recordId: string;
}

const DOCXLicenseAgreementButton = (props: Props) => {
  return (
    <Button
      label={'Лицензионный договор в DOCX'}
      onClick={() => download(props.recordId, 'licenseAgreement')}
    >
      <GetApp />
    </Button>
  );
};

export default DOCXLicenseAgreementButton;
